import Configuration from '@/agilis/util/Configuration'
import { mapActions, mapGetters } from 'vuex'
import L from 'lodash'

export default {
  name: 'DataTableItemDeleteMixin',

  props: {
    api: String
  },

  data () {
    return {
      itemDTO: null,
      parentDTO: null
    }
  },

  computed: {
    ...mapGetters({
      applicationId: 'contextStore/applicationId',
      selectedAppConfig: 'contextStore/application',
      workspaceId: 'contextStore/workspaceId',
      trackerId: 'contextStore/trackerId',
      trackerTypes: 'contextStore/trackerTypes',
      trackerTypeId: 'contextStore/trackerTypeId'
    }),
    computedDeleteTitle () {
      const title = `${this.$t(this.trackerTypes[this.computedTrackerTypeId].name)}${this.mode === 'insert' ? '' : ' ' + (this.itemDTO?.id || this.trackerId)}`
      return Configuration.i18n.capitalizePhrase(title)
    },
    deleteNo () {
      return this.$t('label.deleteNo')
    },
    deleteYes () {
      return this.$t('label.deleteYes')
    },
    computedTrackerTypeId () {
      return this.itemDTO?.trackerTypeId || this.trackerTypeId
    },
    computedApi () {
      return this.itemDTO.trackerTypeId
        ? this.$axios.agilisUrlTracker(this.applicationId, this.itemDTO.trackerTypeId)
        : this.api
    },
    computedDeleteUrl () {
      return this.itemDTO.trackerTypeId
        ? this.$axios.agilisUrlTrackerEdit(this.applicationId, this.itemDTO.trackerTypeId, this.itemDTO.id)
        : this.$axios.agilisUrlDataTableEdit(this.api, this.itemDTO.id)
    }
  },

  methods: {
    ...mapActions({
      'notifyError': 'notificationStore/notifyError',
      'notifyUserConfirm': 'notificationStore/notifyUserConfirm'
    }),
    deleteMessage (param) {
      let message = ''
      if (this.trackerTypes[this.computedTrackerTypeId].deleteMessage) {
        message = this.$t(this.trackerTypes[this.computedTrackerTypeId].deleteMessage)
      } else {
        message = this.$t('label.deleteMessage', { param: param || this.$t(this.trackerTypes[this.computedTrackerTypeId].name) })
      }
      return Configuration.i18n.capitalizePhrase(message)
    },
    async fetchDataDelete () {
      const api = this.computedApi
      const url = this.$axios.agilisUrlDataTableEdit(api, this.itemDTO.id)
      try {
        const response = await this.$axios
          .get(
            url,
            this.$axios.agilisRequestConfig(url))
        this.itemDTO = L.merge({}, this.itemDTO, response.data)
      } catch (error) {
        this.notifyError(error)
      }
    },
    async deleteItem () {
      try {
        await this.fetchDataDelete()
        const url = this.computedDeleteUrl
        await this.$axios
          .delete(
            url,
            {
              ...this.$axios.agilisRequestConfig(url),
              data: this.getDeleteBackendObj()
            })
        this.onDeleteItemDone()
      } catch (error) {
        this.notifyError(error)
      }
    },
    getDeleteBackendObj () {
      return {
        ...this.itemDTO,
        trackerId: this.itemDTO.id,
        'workspaceId': this.workspaceId,
        'applicationId': this.applicationId
      }
    },

    onDeleteItemDone () {
      this.$router.agilis.viewTrackerTable()
    },

    handleDeleteItem (itemDTO, parentDTO) {
      this.itemDTO = L.merge({}, itemDTO)
      this.parentDTO = parentDTO && L.merge({}, parentDTO)

      const userConfirmPromise = this.notifyUserConfirm({
        title: this.computedDeleteTitle,
        messages: [this.deleteMessage()],
        confirm: this.deleteNo,
        cancel: this.deleteYes
      })

      userConfirmPromise.then((userResponse) => {
        if (!userResponse) {
          this.deleteItem()
        } else {
          this.itemDTO = null
          this.parentDTO = null
        }
      })
    }
  }
}
